'use strict';

angular.module('shiftTraderApp')
  .directive('positionsAssignment', ['PositionsStore', function (PositionsStore) {
    return {
      templateUrl: 'views/positionsAssignment/positionsAssignment.html',
      restrict: 'A',
      scope: {
        restrict: '=',
        user: '=positionsAssignment',
        positions: '=?'
      },
      controllerAs: 'posAssign',
      bindToController: true,
      controller: ['$scope', function ($scope) {
        var vm = this

        if (!vm.positions) {
          PositionsStore.getAllActive()
            .then(function (pos) {
              vm.positions = pos
            })
        }

      }]
    }
  }])
